import React, { useEffect, useState } from "react";
import Hero from "../Images/main.jpg";
import Navbar from "../Components/Navbar";
import SearchBar from "../Components/SearchBar";
// import imgtest from "../Images/main.jpg";
import { catalogApi } from "../api/client";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import MainCategoryCard from "../Components/MainCategoryCard";
import { Bell } from "lucide-react";
import sideImg from "../Images/sideImg.png";

import blogs from "../Components/Data/blogData";

import S1 from "../Images/States/andhraPradesh.png";
import S2 from "../Images/States/arunachalPradesh.png";
import S3 from "../Images/States/assam.png";
import S4 from "../Images/States/bihar.png";
import S5 from "../Images/States/chattisgarh.png";
import S6 from "../Images/States/delhi.jpg";
import S7 from "../Images/States/goa.png";
import S8 from "../Images/States/gujarat.png";
import S9 from "../Images/States/haryana.png";
import S10 from "../Images/States/himachalPradesh.png";
import S11 from "../Images/States/jharkhand.png";
import S12 from "../Images/States/karnataka.png";
import S13 from "../Images/States/kerala.png";
import S14 from "../Images/States/madhyaPradesh.png";
import S15 from "../Images/States/maharastra.png";
import S16 from "../Images/States/manipur.png";
import S17 from "../Images/States/meghalya.png";
import S18 from "../Images/States/mizoram.png";
import S19 from "../Images/States/nagaland.png";
import S20 from "../Images/States/odisha.png";
import S21 from "../Images/States/punjab.png";
import S22 from "../Images/States/rajasthan.png";
import S23 from "../Images/States/sikkim.png";
import S24 from "../Images/States/tamilNadu.png";
import S25 from "../Images/States/telangana.png";
import S26 from "../Images/States/tripura.png";
import S27 from "../Images/States/uttarPradesh.png";
import S28 from "../Images/States/uttrakhand.png";
import S29 from "../Images/States/westBengal.png";
import EnquiryForm from "../Components/EnquiryForm";

// Static states data (copied from Location.jsx)
const STATES = [
  { name: "Andhra Pradesh", img: S1, latitude: 15.9129, longitude: 79.74 },
  { name: "Arunachal Pradesh", img: S2, latitude: 28.218, longitude: 94.7278 },
  { name: "Assam", img: S3, latitude: 26.2006, longitude: 92.9376 },
  { name: "Bihar", img: S4, latitude: 25.0961, longitude: 85.3131 },
  { name: "Chhattisgarh", img: S5, latitude: 21.2787, longitude: 81.8661 },
  { name: "Delhi", img: S6, latitude: 28.7041, longitude: 77.1025 },
  { name: "Goa", img: S7, latitude: 15.2993, longitude: 74.124 },
  { name: "Gujarat", img: S8, latitude: 22.2587, longitude: 71.1924 },
  { name: "Haryana", img: S9, latitude: 29.0588, longitude: 76.0856 },
  { name: "Himachal Pradesh", img: S10, latitude: 31.1048, longitude: 77.1734 },
  { name: "Jharkhand", img: S11, latitude: 23.6102, longitude: 85.2799 },
  { name: "Karnataka", img: S12, latitude: 15.3173, longitude: 75.7139 },
  { name: "Kerala", img: S13, latitude: 10.8505, longitude: 76.2711 },
  { name: "Madhya Pradesh", img: S14, latitude: 22.9734, longitude: 78.6569 },
  { name: "Maharashtra", img: S15, latitude: 19.7515, longitude: 75.7139 },
  { name: "Manipur", img: S16, latitude: 24.6637, longitude: 93.9063 },
  { name: "Meghalaya", img: S17, latitude: 25.467, longitude: 91.3662 },
  { name: "Mizoram", img: S18, latitude: 23.1645, longitude: 92.9376 },
  { name: "Nagaland", img: S19, latitude: 26.1584, longitude: 94.5624 },
  { name: "Odisha", img: S20, latitude: 20.9517, longitude: 85.0985 },
  { name: "Punjab", img: S21, latitude: 31.1471, longitude: 75.3412 },
  { name: "Rajasthan", img: S22, latitude: 27.0238, longitude: 74.2179 },
  { name: "Sikkim", img: S23, latitude: 27.533, longitude: 88.5122 },
  { name: "Tamil Nadu", img: S24, latitude: 11.1271, longitude: 78.6569 },
  { name: "Telangana", img: S25, latitude: 18.1124, longitude: 79.0193 },
  { name: "Tripura", img: S26, latitude: 23.9408, longitude: 91.9882 },
  { name: "Uttar Pradesh", img: S27, latitude: 26.8467, longitude: 80.9462 },
  { name: "Uttarakhand", img: S28, latitude: 30.0668, longitude: 79.0193 },
  { name: "West Bengal", img: S29, latitude: 22.9868, longitude: 87.855 },
];

// Using Lorem Picsum with category-specific seeds for consistent, relevant images
const PLACEHOLDER_IMAGE = "https://via.placeholder.com/400x300?text=No+Image";

// Image cache to avoid repeated requests
const imageCache = new Map();

// Category-specific image seeds for Lorem Picsum (each category gets a consistent image)
const categoryImageSeeds = {
  "Software & IT": 1,
  Healthcare: 2,
  Education: 3,
  "Food & Beverage": 4,
  Automotive: 5,
  "Beauty & Wellness": 6,
  "Home & Garden": 7,
  "Sports & Fitness": 8,
  "Travel & Tourism": 9,
  "Real Estate": 10,
  "Legal Services": 11,
  "Financial Services": 12,
  "Emergency Services": 13,
  "Cleaning Services": 14,
  "Repair Services": 15,
  Photography: 16,
  "Event Planning": 17,
  Consulting: 18,
  Transportation: 19,
  Entertainment: 20,
};

function getCategoryImage(categoryName) {
  if (imageCache.has(categoryName)) {
    return imageCache.get(categoryName);
  }
  let seed = categoryImageSeeds[categoryName];
  if (!seed) {
    seed = categoryName.split("").reduce((a, b) => {
      a = (a << 5) - a + b.charCodeAt(0);
      return a & a;
    }, 0);
    seed = Math.abs(seed) % 1000;
  }
  const imageUrl = `https://picsum.photos/seed/${seed}/400/300`;
  imageCache.set(categoryName, imageUrl);
  return imageUrl;
}

async function fetchCategoryImage(categoryName) {
  return getCategoryImage(categoryName);
}

const countries = [
  {
    name: "India",
    gif: "https://cdn.pixabay.com/animation/2022/08/21/20/03/20-03-41-348_512.gif",
  },
  {
    name: "Dubai",
    gif: "https://cdn.pixabay.com/animation/2022/09/16/16/43/16-43-28-59_512.gif",
  },
  {
    name: "Ireland",
    gif: "https://cdn.pixabay.com/animation/2022/08/21/20/03/20-03-50-93_512.gif",
  },
  {
    name: "Canada",
    gif: "https://cdn.pixabay.com/animation/2022/08/07/20/19/20-19-38-788_512.gif",
  },
  {
    name: "Germany",
    gif: "https://cdn.pixabay.com/animation/2022/08/15/03/40/03-40-50-274_512.gif",
  },
  {
    name: "France",
    gif: "https://cdn.pixabay.com/animation/2022/08/14/03/56/03-56-00-644_512.gif",
  },
  {
    name: "USA",
    gif: "https://cdn.pixabay.com/animation/2023/04/01/21/02/21-02-52-586_512.gif",
  },
  {
    name: "UK",
    gif: "https://cdn.pixabay.com/animation/2024/05/16/07/53/07-53-29-101_512.gif",
  },
  {
    name: "Japan",
    gif: "https://cdn.pixabay.com/animation/2022/08/22/04/37/04-37-52-465_512.gif",
  },
  {
    name: "China",
    gif: "https://cdn.pixabay.com/animation/2022/08/07/20/19/20-19-52-205_512.gif",
  },
  {
    name: "Brazil",
    gif: "https://cdn.pixabay.com/animation/2022/08/05/18/24/18-24-53-297_512.gif",
  },
  {
    name: "Russia",
    gif: "https://cdn.pixabay.com/animation/2022/09/08/04/49/04-49-05-31_512.gif",
  },
  {
    name: "Italy",
    gif: "https://cdn.pixabay.com/animation/2022/08/22/04/37/04-37-48-281_512.gif",
  },
  {
    name: "Spain",
    gif: "https://cdn.pixabay.com/animation/2022/09/13/17/55/17-55-34-595_512.gif",
  },
  {
    name: "Australia",
    gif: "https://cdn.pixabay.com/animation/2022/08/01/03/42/03-42-57-408_512.gif",
  },
  {
    name: "Mexico",
    gif: "https://cdn.pixabay.com/animation/2022/08/29/18/03/18-03-54-932_512.gif",
  },
  {
    name: "Egypt",
    gif: "https://cdn.pixabay.com/animation/2022/08/09/18/30/18-30-48-957_512.gif",
  },
  {
    name: "South Korea",
    gif: "https://cdn.pixabay.com/animation/2022/09/13/17/55/17-55-29-740_512.gif",
  },
  {
    name: "Thailand",
    gif: "https://cdn.pixabay.com/animation/2022/09/16/16/43/16-43-00-626_512.gif",
  },
  {
    name: "Turkey",
    gif: "https://cdn.pixabay.com/animation/2022/09/16/16/43/16-43-14-951_512.gif",
  },
];

const Home = () => {
  const [categories, setCategories] = useState([]);
  const [categoryImages, setCategoryImages] = useState({});
  const [imagesLoading, setImagesLoading] = useState(false);
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const navigate = useNavigate();
  const [viewportWidth, setViewportWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1024
  );

  useEffect(() => {
    catalogApi.listCategories().then((data) => setCategories(data.items || []));
  }, []);

  // Fetch images for all categories when categories change
  useEffect(() => {
    async function loadImages() {
      if (categories.length === 0) return;

      // console.log(
      //   `🚀 Starting to load images for ${categories.length} categories`
      // );
      setImagesLoading(true);
      setImagesLoaded(false);

      const images = {};
      const loadPromises = [];

      // Load images in parallel for better performance
      for (const cat of categories) {
        const promise = fetchCategoryImage(cat.name)
          .then((imageUrl) => {
            images[cat._id] = imageUrl;
            // console.log(`✅ Loaded image for "${cat.name}": ${imageUrl}`);
          })
          .catch((error) => {
            console.error(`❌ Failed to load image for "${cat.name}":`, error);
            images[cat._id] = PLACEHOLDER_IMAGE;
          });
        loadPromises.push(promise);
      }

      try {
        await Promise.all(loadPromises);
        // console.log(`🎉 All images loaded successfully!`);
        setCategoryImages(images);
        setImagesLoaded(true);
      } catch (error) {
        console.error(`💥 Error loading images:`, error);
        setCategoryImages(images); // Set whatever we managed to load
        setImagesLoaded(true);
      } finally {
        setImagesLoading(false);
      }
    }

    loadImages();
  }, [categories]);

  useEffect(() => {
    const handleResize = () => setViewportWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const sliderSettings = {
    dots: false,
    infinite: categories.length > 5,
    speed: 500,
    slidesToShow:
      viewportWidth < 600
        ? Math.min(3, categories.length) // mobile
        : viewportWidth < 1400
        ? Math.min(3, categories.length) // tablet
        : Math.min(5, categories.length), // web → 5 slides
    slidesToScroll: 2,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: Math.min(4, categories.length), // tablet
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: Math.min(2, categories.length), // mobile
        },
      },
    ],
  };

  const handleCategoryClick = (category) => {
    navigate(`/services?categoryIds=${category._id}`);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      });
    });
  };

  // For location slider
  const locationSliderSettings = {
    dots: false,
    infinite: STATES.length > 4,
    speed: 500,
    slidesToShow:
      viewportWidth < 600
        ? Math.min(3, STATES.length)
        : viewportWidth < 1400
        ? Math.min(3, STATES.length)
        : Math.min(5, STATES.length),
    slidesToScroll: 2,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: Math.min(2, STATES.length),
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: Math.min(1, STATES.length),
        },
      },
    ],
  };

  const handleLocationClick = (state) => {
    navigate(`/services?lat=${state.latitude}&lng=${state.longitude}`);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      });
    });
  };

  const blogsSliderSettings = {
    dots: false,
    infinite: categories.length > 4,
    speed: 500,
    slidesToShow:
      viewportWidth < 600
        ? Math.min(1, categories.length)
        : viewportWidth < 1024
        ? Math.min(2, categories.length)
        : Math.min(3, categories.length),
    slidesToScroll: 2,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: Math.min(2, categories.length),
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: Math.min(1, categories.length),
        },
      },
    ],
  };

  const handleClick = (id) => {
    navigate(`/blogs/${id}`);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      });
    });
  };

  return (
    <>
      <section className="relative w-full h-full md:h-screen overflow-hidden">
        <img
          src={Hero}
          alt="Hero Background"
          className="absolute inset-0 w-full h-full object-cover z-[-10] blur-sm"
        />
        <Navbar />
        <div className="absolute inset-0 bg-black/70 z-[-5]" />
        <div className="relative z-10 h-full text-white flex flex-col justify-center items-center">
          <div className="h-3/4 w-3/4 text-white flex flex-col justify-center items-center gap-3 md:gap-5">
            <h1 className="text-base md:text-xl font-bold text-center tracking-widest mulish-light uppercase">
              Welcome to <br />
              <span className=" text-xl sm:text-3xl md:text-6xl poppins-semibold tracking-wider bg-gradient-to-r from-orange-500 via-white to-green-500 bg-clip-text text-transparent ">
                ONLINE INDIAN MARKET
              </span>
            </h1>
            <p className="md:mt-2 text-sm sm:text-lg mulish-light text-center tracking-wider uppercase">
              Get the Nearest and Best Services in the Market.
            </p>
            <SearchBar />
            <div className="flex w-full flex-row justify-around pb-5 md:pb-10 ">
              <MainCategoryCard data={categories} />
            </div>
          </div>
        </div>
      </section>

      <section className="w-full flex flex-col items-center justify-center p-4 sm:p-10  gap-2 sm:gap-6">
        {/* Heading */}
        <h1 className=" poppins-semibold text-lg  sm:text-2xl md:text-4xl tracking-wider text-center uppercase">
          What kind of Service you are looking for?
        </h1>

        {/* Subtext */}
        <p className="poppins-light text-sm sm:text-xl max-w-3xl text-center text-gray-700">
          We’re here to make your search easier — just tell us what you need,
          and we’ll connect you with the right services.
        </p>

        {/* Slider */}
        <div className="w-full">
          {imagesLoading && (
            <div className="flex justify-center items-center py-4 sm:py-8">
              <div className="flex flex-col items-center gap-3">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500"></div>
                <p className="text-sm text-gray-600">
                  Loading category images...
                </p>
              </div>
            </div>
          )}

          <Slider
            key={`cat-${viewportWidth}-${imagesLoaded}`}
            {...sliderSettings}
          >
            {categories.map((item, idx) => (
              <div key={item._id || idx} className="px-2">
                <div
                  className="relative w-full sm:w-[90%] md:w-72 aspect-square rounded-2xl overflow-hidden border border-white shadow-md group cursor-pointer mx-auto"
                  onClick={() => handleCategoryClick(item)}
                >
                  <img
                    src={categoryImages[item._id] || PLACEHOLDER_IMAGE}
                    alt={item.name}
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                    onError={(e) => {
                      console.warn(
                        `🖼️ Image failed to load for "${item.name}", using placeholder`
                      );
                      e.target.src = PLACEHOLDER_IMAGE;
                    }}
                    onLoad={() => {
                      // console.log(
                      //   `🖼️ Image loaded successfully for "${item.name}"`
                      // );
                    }}
                  />
                  <div className="absolute inset-0 bg-black/50 transition group-hover:bg-gradient-to-br from-orange-500 to-green-900 group-hover:opacity-80" />
                  <div className="relative z-10 h-full w-full flex flex-col justify-center items-center text-white text-center p-3">
                    <span className="text-xs sm:text-base md:text-xl font-semibold text-gray-900 px-3 py-1 bg-white/50 poppins-regular rounded-2xl">
                      {item.name}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
        {/* Heading */}
        <h1 className="poppins-semibold text-lg sm:text-2xl md:text-4xl tracking-wider text-center uppercase">
          Where do you need your Service?
        </h1>
        {/* Slider for locations */}
        <div className="w-full">
          <Slider key={`loc-${viewportWidth}`} {...locationSliderSettings}>
            {STATES.map((state, idx) => (
              <div key={state.name || idx} className="px-2">
                <div
                  className="relative w-full sm:w-[90%] md:w-72 aspect-square rounded-2xl overflow-hidden border border-white shadow-md group cursor-pointer mx-auto"
                  onClick={() => handleLocationClick(state)}
                >
                  <img
                    src={state.img}
                    alt={state.name}
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-black/50 transition group-hover:bg-gradient-to-br from-orange-500 to-green-900 group-hover:opacity-80" />
                  <div className="relative z-10 h-full w-full flex flex-col justify-center items-center text-white text-center p-3">
                    <span className="text-sm sm:text-base md:text-xl font-semibold text-gray-900 px-3 py-1 bg-white/50 poppins-regular rounded-2xl">
                      {state.name}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </section>
      <section className="w-full h-full flex flex-col justify-center items-center py-5 sm:py-16 sm:px-10 bg-gray-200 gap-5 sm:gap-10">
        <h1 className="poppins-semibold text-xl tracking-wider sm:text-2xl md:text-3xl flex flex-col justify-center items-center uppercase text-center">
          How it Works?
          <span className="w-4/5 outline outline-1 mt-2 outline-neutral-500"></span>
        </h1>

        <div className="flex flex-col md:flex-row justify-center items-center w-full md:w-10/12 gap-5 sm:gap-8">
          {/* Steps Container */}
          <div className="flex flex-col justify-center items-center gap-5 sm:gap-8 w-full md:w-2/3">
            {/* STEP 1 */}
            <div className="flex flex-col sm:flex-row gap-6 sm:gap-10 justify-center items-center sm:items-start w-full text-center sm:text-left">
              {/* ICON HIDDEN ON MOBILE */}
              <div className="hidden sm:flex bg-purple-900 text-white rounded-full p-3 sm:p-4 justify-center items-center">
                <Bell className="h-6 w-6 sm:h-8 sm:w-8" />
              </div>

              <div className="flex flex-col items-center sm:items-start">
                <strong className="poppins-semibold tracking-wider text-sm sm:text-xl text-neutral-800">
                  Get Discovered by Local Customers
                </strong>

                {/* MOBILE CONTENT */}
                <p className="text-sm w-11/12 poppins-regular text-neutral-700 sm:hidden">
                  By listing your services, you instantly become visible to
                  people searching for providers in your area. Whether you’re a
                  plumber, tutor, shop, or consultant — customers can find you
                  easily.
                </p>

                {/* DESKTOP CONTENT */}
                <p className="hidden sm:block text-md w-11/12 poppins-regular text-neutral-700">
                  By listing your services, you instantly become visible to
                  people searching for providers in your area. Whether you’re a
                  plumber, tutor, shop, or consultant — customers can find you
                  easily.
                </p>
              </div>
            </div>

            {/* STEP 2 */}
            <div className="flex flex-col sm:flex-row gap-6 sm:gap-10 justify-center items-center sm:items-start w-full text-center sm:text-left">
              <div className="hidden sm:flex bg-purple-900 text-white rounded-full p-3 sm:p-4 justify-center items-center">
                <Bell className="h-6 w-6 sm:h-8 sm:w-8" />
              </div>

              <div className="flex flex-col items-center sm:items-start">
                <strong className="poppins-semibold tracking-wider text-sm sm:text-xl text-neutral-800">
                  Build Trust with Verified Profiles
                </strong>

                {/* MOBILE */}
                <p className="text-sm w-11/12 poppins-regular text-neutral-700 sm:hidden">
                  Your profile includes business details, documents, and reviews
                  to build trust.
                </p>

                {/* DESKTOP */}
                <p className="hidden sm:block text-md w-11/12 poppins-regular text-neutral-700">
                  Your profile includes business details, documents (GST, PAN,
                  etc.), and reviews, which help build credibility. A complete
                  profile means customers are more likely to choose you over
                  competitors.
                </p>
              </div>
            </div>

            {/* STEP 3 */}
            <div className="flex flex-col sm:flex-row gap-6 sm:gap-10 justify-center items-center sm:items-start w-full text-center sm:text-left">
              <div className="hidden sm:flex bg-purple-900 text-white rounded-full p-3 sm:p-4 justify-center items-center">
                <Bell className="h-6 w-6 sm:h-8 sm:w-8" />
              </div>

              <div className="flex flex-col items-center sm:items-start">
                <strong className="poppins-semibold tracking-wider text-sm sm:text-xl text-neutral-800">
                  Showcase Your Services & Offers
                </strong>

                {/* MOBILE */}
                <p className="text-sm w-11/12 poppins-regular text-neutral-700 sm:hidden">
                  Show prices, images & services like a mini online shop.
                </p>

                {/* DESKTOP */}
                <p className="hidden sm:block text-md w-11/12 poppins-regular text-neutral-700">
                  You can highlight multiple products/services, prices, images,
                  and descriptions. This acts like a mini online shop for your
                  business, attracting customers already looking for what you
                  offer.
                </p>
              </div>
            </div>

            {/* STEP 4 */}
            <div className="flex flex-col sm:flex-row gap-6 sm:gap-10 justify-center items-center sm:items-start w-full text-center sm:text-left">
              <div className="hidden sm:flex bg-purple-900 text-white rounded-full p-3 sm:p-4 justify-center items-center">
                <Bell className="h-6 w-6 sm:h-8 sm:w-8" />
              </div>

              <div className="flex flex-col items-center sm:items-start">
                <strong className="poppins-semibold tracking-wider text-sm sm:text-xl text-neutral-800">
                  Grow with More Leads & Conversions
                </strong>

                {/* MOBILE */}
                <p className="text-sm w-11/12 poppins-regular text-neutral-700 sm:hidden">
                  More visibility = more inquiries & conversions.
                </p>

                {/* DESKTOP */}
                <p className="hidden sm:block text-md w-11/12 poppins-regular text-neutral-700">
                  The directory brings continuous traffic from people actively
                  searching. More visibility → more inquiries → more conversions
                  → steady growth for your business.
                </p>
              </div>
            </div>
          </div>

          {/* Image */}
          <img
            src={sideImg}
            className="h-auto w-4/5 sm:w-2/3 md:w-2/5 object-contain"
            alt="TestImage"
          />
        </div>

        <strong className="poppins-semibold text-xs md:text-xl text-center text-black tracking-wider uppercase ">
          List → Get Found → Build Trust → Get More Customers → Grow.
        </strong>
      </section>

      <div className="bg-gray-100 w-full py-4">
        <EnquiryForm />
      </div>

      <section className="w-full h-full  py-5 ">
        <h1 className="mulish-bold tracking-wider text-2xl sm:text-3xl text-center uppercase mb-5">
          Read Some Blogs.
        </h1>
        <div className="w-10/12 mx-auto">
          <Slider key={`loc-${viewportWidth}`} {...blogsSliderSettings}>
            {blogs.map((blog) => (
              <div key={blog.id} className="p-5">
                <div
                  onClick={() => handleClick(blog.id)}
                  className=" relative w-full cursor-pointer bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-lg transition flex flex-col h-[300px]" // fixed height
                >
                  {/* Image */}
                  <img
                    src={blog.image}
                    alt={blog.title}
                    className="w-full h-48 object-cover"
                  />

                  {/* Content */}
                  <div className="p-4 flex flex-col flex-grow">
                    <h3 className="text-lg font-semibold line-clamp-2">
                      {blog.title}
                    </h3>

                    {/* Description with clamp */}
                    <p className="text-sm text-gray-600 mt-2 line-clamp-3 flex-grow">
                      {blog.description}
                    </p>

                    {/* Read More always at bottom */}
                    <div className="mt-auto">
                      <span className="text-blue-500 font-medium">
                        Read More →
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </section>
      {/* <section>
        <div className="bg-white py-4 mt-8">
          <div className="container mx-auto px-4 flex flex-wrap gap-[5px] md:gap-2 justify-center text-sm">
            {[
              
              "United States",
              "Canada",
              "United Kingdom",
              "Germany",
              "France",
              "Italy",
              "Spain",
              "Russia",
              "China",
              "Japan",
              "South Korea",
              "Singapore",
              "Australia",
              "Brazil",
              "Mexico",
              "South Africa",
              "UAE",
              "Saudi Arabia",
              "Qatar",
              "Turkey",
              "India",
              "Pakistan",
              "Bangladesh",
              "Nepal",
              "Sri Lanka",
              "Malaysia",
              "Indonesia",
              "Thailand",
              "Vietnam",
              "Philippines",
              "Nigeria",
              "Kenya",
              "Egypt",
              "Argentina",
            ].map((country) => (
              <span
                key={country}
                className=" px-1 md:px-3 md:py-1 text-[7px] md:text-[12px] bg-white border rounded-full text-gray-700 hover:bg-blue-50 cursor-pointer"
              >
                {country}
              </span>
            ))}
          </div>
        </div>
      </section> */}

      <div className="overflow-hidden w-full py-6 bg-gray-100">
        <div className=" flex animate-marquee-responsive space-x-0">
          {countries.map((country, index) => (
            <div
              key={index}
              className="flex-shrink-0 w-28 md:w-56 flex flex-col items-center"
            >
              <img
                src={country.gif}
                alt={country.name}
                className="w-20 h-16 md:w-40 md:h-28 object-cover rounded-s-sm"
              />
              <p className="mt-1 md:mt-2 text-sm font-semibold text-gray-900">
                {country.name}
              </p>
            </div>
          ))}
        </div>

        {/* Tailwind animation for right-to-left scrolling */}
        <style>
          {`
    @keyframes marquee-pc {
      0% { transform: translateX(100%); }
      100% { transform: translateX(-100%); }
    }

    @keyframes marquee-phone {
      0% { transform: translateX(100%); }
      100% { transform: translateX(-100%); }
    }

    .animate-marquee-responsive {
      display: flex;
      gap: 1.5rem;
      animation: marquee-pc 30s linear infinite;
    }

    /* Media Query – Phone screens */
    @media (max-width: 1023px) {
      .animate-marquee-responsive {
        animation: marquee-phone 10s linear infinite;
      }
    }
  `}
        </style>
      </div>
    </>
  );
};

export default Home;
